<template>
    <div class="section section-planes-detalle">
        <div class="container">
            <div id="planes-detalle">
                <div class="row">
                    <div class="col-md-12">                        
                        <tabs pills type="primary">
                            <tab-pane v-for="item in planes" :key="item.id" :label="item.nombre" center>
                                <p v-html="item.descripcion" ></p>
                                <p v-html="item.beneficios" ></p>                               
                            </tab-pane>                                                
                        </tabs>
                    </div>
                </div>                
            </div>
        </div>
    </div>
</template>
<script>
import { Card, Tabs, TabPane } from "@/components";

export default {
  components: {
    Card,
    Tabs,
    TabPane
  },
  data() {
    return {
      planes: []
    };
  },
  mounted() {
    this.$zaiq().get("Plan/GetAll").then(response => {
      console.log(response.data.result.items);
      this.planes = response.data.result.items;
    });
  }
};
</script>
<style>
</style>